// removed by extract-text-webpack-plugin
module.exports = {"Menu":"DrawerToggle__Menu__G6JWO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/DrawerToggle/DrawerToggle.css
// module id = 297
// module chunks = 3